import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BookingPaxTypeDocumentProps } from '@app/entities/booking-documents';
import { PAX_TO_TRAVELER } from '@pax/entities/pax-ui';
import { AppFacade } from '@app/app.facade';
import { PaxType } from '@booking/entities/pax-type';

@Pipe({
  name: 'travelerDocuments',
  standalone: false
})
export class TravelerDocumentsPipe implements PipeTransform {

  constructor(
    private appFacade: AppFacade,
  ) { }

  transform(paxType: PaxType): Observable<BookingPaxTypeDocumentProps[]> {
    return this.appFacade.documentAssets$.pipe(
      map(_ENV => ({ _ENV, travelerType: PAX_TO_TRAVELER[paxType] })),
      map(({ _ENV, travelerType }) => _ENV?.PAX && _ENV.PAX[travelerType] ? _ENV.PAX[travelerType] : [])
    );
  }
}
